
<template>
  <div class="search-type">
    <p>
      <span class="search-item">
        <span class="search-label">产品类别：</span>
        <el-radio-group v-model="secondCategory" @change="secondCategoryChange">
          <el-radio
            v-for="item in secondCategoryList"
            :key="item.value"
            :label="item.value"
            :name="item.value"
          >{{ item.label }}</el-radio>
          <el-button type="text" @click="onReset('secondCategory')">清空</el-button>
        </el-radio-group>
      </span>
    </p>
    <p v-show="productCategoryList.length > 0">
      <span class="search-item">
        <span class="search-label">产品品类：</span>
        <el-radio-group v-model="productCategory" @change="productCategoryChange">
          <el-radio
            v-for="item in productCategoryList"
            :key="item.value"
            :label="item.value"
            :name="item.value"
          >{{ item.label }}</el-radio>
          <el-button type="text" @click="onReset('productCategory')">清空</el-button>
        </el-radio-group>
      </span>
    </p>
  </div>
</template>
<script>
export default {
  data() {
    return {
      secondCategoryList: [],
      productCategoryList: [],
      secondCategory: '',
      productCategory: ''
    };
  },
  mounted() {
    this.getDictList();
  },
  methods: {
    getDictList() {
      this.$http.pdLibrary.listByFirstCategory('MATERIAL').then((res) => {
        this.secondCategoryList = res.data.map(item => ({
          label: item.secondCategoryName,
          value: item.secondCategory
        }));
      })
    },
    secondCategoryChange (val) {
      this.$emit('change-list', { secondCategory: val, productCategory: '' });
      this.productCategory = '';
      const { gift_product_category } = this.$store.getters.allDictListData.data;
      this.productCategoryList = gift_product_category.filter(item => item.value.split('_')[0] === val);
    },
    productCategoryChange(val) {
      this.$emit('change-list', { productCategory: val });
    },
    onReset(val) {
      if (val === 'secondCategory') {
        this.productCategory = '';
        this.secondCategory = '';
        this.productCategoryList = [];
        this.$emit('change-list', { secondCategory: '', productCategory: '' });
      } else {
        this.productCategory = '';
        this.$emit('change-list', { productCategory: '' });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.search-type {
  margin-bottom: 10px;
  /deep/ .el-input,.el-input__inner {
    width: 100px;
  }
  i {
    display: inline-block;
    margin: 0 5px;
    height: 28px;
    line-height: 28px;
  }
  .search-item {
    display: flex;
    align-items: flex-start;
    margin-top: 3px;
    padding: 5px 0;
    font-size: 14px;
    border-bottom: 1px dashed #ccc;
    .search-label {
      display: inline-block;
      min-width: 80px;
      line-height: 24px;
    }
    .checkbox-group {
      margin: 0;
    }
  }
  p {
    &:last-child span {
      border-bottom: none;
    }
  }
}
</style>
